import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import {OwnershipTransferPrivateSellerStep, MessageContent, ServiceType, PopupMessageContent, ProductType} from './Constant/Constant';

export const submitServiceValidation = createAsyncThunk(
  'OwnershipTransferPrivateSeller/submitServiceValidation',
  async (data, thunkAPI) => {
    thunkAPI.dispatch(showAppLoader());
    try {
      const result = await ProviderManager.getProviderData('submitTransferServiceValidation', data);
      thunkAPI.dispatch(hideAppLoader());
      return result.Body;
    } catch (error) {
      thunkAPI.dispatch(hideAppLoader());
      return error;
    }
  },
);
export const createWorkOrder = createAsyncThunk('OwnershipTransferPrivateSeller/createWorkOrder', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('createWorkOrderOwnershipTransfer', data);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return error;
  }
});
export const createOwnershipTransferSellerRequest = createAsyncThunk(
  'OwnershipTransferPrivateSeller/createOwnershipTransferSellerRequest',
  async (data, thunkAPI) => {
    thunkAPI.dispatch(showAppLoader());
    try {
      const result = await ProviderManager.getProviderData('createOwnershipTransferSellerRequest', data);
      thunkAPI.dispatch(hideAppLoader());
      return result.Body;
    } catch (error) {
      thunkAPI.dispatch(hideAppLoader());
      return error;
    }
  },
);

const initialState = {
  currentStep: '',
  showPopup: false,
  currentPopupData: null,
  selectedServiceType: '',
  serviceToTransfer: null,
  selectedProductType: '',
  buyerPersonalData: {
    firstName: '',
    lastName: '',
    idNumber: '',
    otpPhone: '',
  },
  failReason: '',
  generalMessage: null,
};

const OwnershipTransferPrivateSellerSlice = createSlice({
  name: 'OwnershipTransferPrivateSeller',
  initialState: initialState,

  reducers: {
    resetState: () => initialState,

    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
      return state;
    },
    setShowPopUp: (state, action) => {
      state.currentPopupData = null;
      state.showPopup = action.payload;
      return state;
    },
    setCurrentPopUp: (state, action) => {
      state.showPopup = true;
      state.currentPopupData = action.payload;
      return state;
    },
    setGeneralMessage: (state, action) => {
      state.generalMessage = action.payload;
    },
    setSelectedServiceType: (state, action) => {
      state.selectedServiceType = action.payload;
    },
    setServiceToTransfer: (state, action) => {
      state.serviceToTransfer = action.payload.item;
      state.selectedProductType = action.payload.productType;
    },
    setBuyerPersonalData: (state, action) => {
      if (action.payload.firstName !== undefined) {
        state.buyerPersonalData.firstName = action.payload.firstName;
      }
      if (action.payload.lastName !== undefined) {
        state.buyerPersonalData.lastName = action.payload.lastName;
      }
      if (action.payload.idNumber !== undefined) {
        state.buyerPersonalData.idNumber = action.payload.idNumber;
      }
      if (action.payload.otpPhone !== undefined) {
        state.buyerPersonalData.otpPhone = action.payload.otpPhone;
      }
    },
  },
  extraReducers: {
    [submitServiceValidation.pending]: (state) => {},
    [submitServiceValidation.fulfilled]: (state, action) => {
      if (!action.payload?.isAxiosError && !action.payload.errorCode) {
        if (action.payload.success) {
          if (action.payload.blocking_dual_number) {
            state.currentStep = OwnershipTransferPrivateSellerStep.BlockingDualNumber;
            return state;
          }
          state.currentStep = OwnershipTransferPrivateSellerStep.BuyerDetails;
          return state;
        } else {
          state.failReason = action.payload.error;
          if (action.payload.error == 'InvalidParameters' || action.payload.error == 'AccountNotFound') {
            state.generalMessage = MessageContent.GeneralError;
            state.currentStep = OwnershipTransferPrivateSellerStep.GeneralMessage;
            return state;
          } else if (action.payload.error == 'Quattro') {
            state.generalMessage = MessageContent.QuattroServiceError;
            state.currentStep = OwnershipTransferPrivateSellerStep.GeneralMessage;
            return state;
          } else if (action.payload.error == 'HasOpenFU') {
            state.generalMessage = MessageContent.CallbackRequestReceived;
            state.currentStep = OwnershipTransferPrivateSellerStep.GeneralMessage;
            return state;
          } else if (action.payload.error == 'HasJetOpenOrder') {
            if (state.selectedServiceType == ServiceType.Cellular) {
              state.currentPopupData = PopupMessageContent.CellularOpenWorkOrder;
            } else {
              state.currentPopupData = PopupMessageContent.OpenWorkOrder;
            }
            state.showPopup = true;
            return state;
          } else if (action.payload.error == 'InvalidPayment') {
            if (action.payload.hasPaymentMethodIssue && action.payload.hasDebt) {
              state.generalMessage = MessageContent.DebtAndPaymentUpdateError;
            } else if (!action.payload.hasPaymentMethodIssue && action.payload.hasDebt) {
              state.generalMessage = MessageContent.DebtError;
            } else {
              state.generalMessage = MessageContent.PaymentUpdateError;
            }
            state.currentStep = OwnershipTransferPrivateSellerStep.GeneralMessage;
            return state;
          } else if (action.payload.error == 'AdditionalId') {
            if (state.selectedServiceType == ServiceType.Cellular) {
              state.generalMessage = MessageContent.CellularAdditionalOwnersError;
            } else {
              state.generalMessage = MessageContent.AdditionalOwnersError;
            }
            state.currentStep = OwnershipTransferPrivateSellerStep.GeneralMessage;
            return state;
          } else if (action.payload.error == 'TechnicianVisit') {
            state.generalMessage = MessageContent.TechnicianVisitError;
            state.currentStep = OwnershipTransferPrivateSellerStep.GeneralMessage;
            return state;
          } else if (action.payload.error == 'SubStatus') {
            state.currentPopupData = PopupMessageContent.CellularSubStatusError;
            state.showPopup = true;
            return state;
          } else if (action.payload.error == 'CellcomDu') {
            state.currentPopupData = PopupMessageContent.CellularCellcomDuError;
            state.showPopup = true;
            return state;
          } else if (action.payload.error == 'InvalidNPStatus') {
            state.currentPopupData = PopupMessageContent.CellularNPStatusError;
            state.showPopup = true;
            return state;
          } else if (action.payload.error == 'Abroad') {
            state.currentPopupData = PopupMessageContent.CellularAbroadError;
            state.showPopup = true;
            return state;
          } else if (action.payload.error == 'Esim') {
            state.currentPopupData = PopupMessageContent.CellularEsimError;
            state.showPopup = true;
            return state;
          } else if (action.payload.error == 'SwitchCode') {
            state.currentPopupData = PopupMessageContent.CellularDataPackageError;
            state.showPopup = true;
            return state;
          } else if (action.payload.error == 'FutureAbroad') {
            state.generalMessage = MessageContent.FutureAbroadError;
            state.currentStep = OwnershipTransferPrivateSellerStep.GeneralMessage;
            return state;
          } else if (action.payload.error == 'IsEnergyBundle') {
            state.currentPopupData = PopupMessageContent.EnergyBundleError;
            state.showPopup = true;
            return state;
          } else {
            state.currentPopupData = PopupMessageContent.CellularGeneralTransferError;
            state.showPopup = true;
            return state;
          }
        }
      } else {
        state.generalMessage = MessageContent.GeneralError;
        state.currentStep = OwnershipTransferPrivateSellerStep.GeneralMessage;
        return state;
      }
    },
    [createWorkOrder.fulfilled]: (state, action) => {
      if (!action.payload?.isAxiosError && !action.payload.errorCode) {
        state.generalMessage = action.payload.isSuccess ? MessageContent.CallbackRequestReceived : MessageContent.GeneralError;
        state.currentStep = OwnershipTransferPrivateSellerStep.GeneralMessage;
        return state;
      }
    },
    [createOwnershipTransferSellerRequest.fulfilled]: (state, action) => {
      if (!action.payload?.isAxiosError && !action.payload.errorCode) {
        if (action.payload.success) {
          if (state.selectedServiceType == ServiceType.Cellular) {
            state.generalMessage = MessageContent.SuccessPageCellular;
          } else {
            state.generalMessage = MessageContent.SuccessPageStationary;
          }
        } else {
          if (action.payload.error == 'IdNumberError') {
            if (state.selectedServiceType == ServiceType.Cellular) {
              state.generalMessage = MessageContent.MustVisitServiceCenterCellular;
            } else {
              state.generalMessage = MessageContent.MustVisitServiceCenter;
            }
          } else {
            state.generalMessage = MessageContent.GeneralError;
          }
          state.currentStep = OwnershipTransferPrivateSellerStep.GeneralMessage;
        }
        state.currentStep = OwnershipTransferPrivateSellerStep.GeneralMessage;
        return state;
      }
    },
  },
});

export const {
  resetState,
  setCurrentStep,
  setShowPopUp,
  setCurrentPopUp,
  setSelectedServiceType,
  setServiceToTransfer,
  setBuyerPersonalData,
  setGeneralMessage,
} = OwnershipTransferPrivateSellerSlice.actions;

export default OwnershipTransferPrivateSellerSlice.reducer;
